import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import {
  RiderContact,
  RiderDetails,
  RiderMustBeMetResponse,
  RiderRequiredServicesResponse,
  RiderSearchResult,
} from '../../types/rider';

export async function getRiderDetails(slug): Promise<ApiResponse<RiderDetails>> {
  return requestWithQuery({ url: `/care/riders/${slug}`, method: 'GET' });
}

interface RiderContactParams {
  riderId: string;
  page: number;
  perPage: number;
}

export async function getRiderContacts(queryParams: RiderContactParams): Promise<ApiResponse<RiderContact[]>> {
  return requestWithQuery({ url: '/care/riders_contacts', method: 'GET', params: queryParams });
}

interface RiderSearchParams {
  q?: string;
  account_id?: number;
}

export async function getRidersSearchQuery(queryParams: RiderSearchParams): Promise<ApiResponse<RiderSearchResult>> {
  return requestWithQuery({ url: '/care/riders', method: 'GET', params: queryParams });
}

interface RiderMustBeMetParams {
  rideSlug: string;
  riderSlug: string;
}

export async function getRidersMustBeMet(
  queryParams: RiderMustBeMetParams
): Promise<ApiResponse<RiderMustBeMetResponse>> {
  return requestWithQuery({
    url: `/care/rides/${queryParams.rideSlug}/riders/${queryParams.riderSlug}/must_be_met`,
    method: 'GET',
  });
}

export async function getRiderRequiredServices(
  rideSlug: string,
  riderSlug: string
): Promise<ApiResponse<RiderRequiredServicesResponse>> {
  return requestWithQuery({
    url: `/care/rides/${rideSlug}/riders/${riderSlug}/required_services`,
    method: 'GET',
  });
}
